<template>
  <div class="listsProducts" :style="`background: ${productFamily.color}`">
    <div class="listContainer d-flex flex-column gap-5">
      <div v-if="detailProduct" class="associatedProducts">
        <h3>Produits associés</h3>
      </div>
      <Product :listProducts="productList" v-if="productList.length > 0" />
      <div class="emptyAssociatedProducts" v-else>Aucun produits associés.</div>
    </div>
  </div>
</template>
<script setup>
import Product from "@/components/altela/Products/index.vue"
import ProductData from "public/static/menu.json";

const route = useRoute()

defineProps({
  detailProduct: Boolean,
  level1: String,
  level2: String,
  level3: String
})

const productFamily = ProductData.filter((elm) => {
  return elm.id === parseInt(route.params.idMenu ?? '')
})[0]

const productCategory = productFamily?.menu?.filter((elm) => {
  return elm.id === parseInt(route.params.idSubMenu ?? '')
})[0]

const productList = productCategory?.menuItem?.filter((elm) => {
  return elm.id !== parseInt(route.params.id ?? '')
})
</script>
<style scoped>
.listsProducts {
  padding: 5rem 17.1875rem;
}

.listContainer {
  padding: 5rem;
  background: #fff;
}

h3 {
  color: var(--secondaire, #003853);
  font-family: Panton;
  font-size: 2.0625rem;
  font-style: italic;
  font-weight: 400;
  line-height: 110%; /* 2.26875rem */
  letter-spacing: 0.04125rem;
  text-transform: uppercase;
}

@media screen and (max-width: 1600px){
  .listsProducts {
    padding: 5rem 2rem;
  }
}

@media screen and (max-width: 810px) {
  .listsProducts {
    padding: 1rem;
  }

  .listContainer {
    padding: 1rem 0 1rem 0;
    row-gap: 1rem !important;
  }

  .associatedProducts {
    margin: auto;
  }

  .associatedProducts h3 {
    font-size: 20px;
  }

  .emptyAssociatedProducts {
    text-align: center;
  }
}
</style>